export const PromoTemplates = [
    {"name": "Standard", "value": "standard"},
    {"name": "No Sale Price", "value": "no_sale_price"},
    {"name": "Minimal", "value": "minimal"}
];